import { render, staticRenderFns } from "./MonthlyStatement.vue?vue&type=template&id=054eb787"
import script from "./MonthlyStatement.vue?vue&type=script&lang=js"
export * from "./MonthlyStatement.vue?vue&type=script&lang=js"
import style0 from "./MonthlyStatement.vue?vue&type=style&index=0&id=054eb787&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports